import { appNavbarId } from "app/constants";

export const changeAppNavbarPosition = (position: string) => document.getElementById(appNavbarId).style.position = position;
export const removeAppNavbarPostion = () => document.getElementById(appNavbarId).style.removeProperty('position');
